import React, {Component} from 'react';
import {
  Row,
  Col
} from 'reactstrap';
import SmartForm from '../../../../components/SmartForm';
import Validator from '../../../../helpers/Validator';
import {USA_STATES, SOUTHERN_CALIFORNIA_PROPERTY_ZONES, SURVEY_TYPES} from '../../../../constants';
// import {
//   getProperty as APIGetUserProperty,
//   createProperty as APICreateUserProperty
// } from '../../../../gateways/users';
import {
  // createProperty as APICreateProperty,
  updateProperty as APIUpdateProperty,
  getProperty as APIGetProperty
} from '../../../../gateways/properties';

class Property extends Component {
  constructor(props) {
    super(props);

    this.state = {
      propertyId: null,
      formValues: {
        propertyname: '',
        address: '',
        city: '',
        state: '',
        survey_type: '',
        zip: '',
        phone: '',
        fax: '',
        contact_name: '',
        contact_title: '',
        contact_email: '',
        manager_name: '',
        no_of_room: 0,
        luxury_flg: false,
        union_flg: false,
        inn_flg: false,
        golf_flg: false,
        limited_flg: false,
        zone_id: 1,
        createdAt: ''
      },
      formErrors: {},
      formAlert: {
        message: "",
        color: "",
        open: false
      }
    };

    this.form = {
      editAble: true,
      fields: [
        {
          "id": "propertyname",
          "text": "Property Name",
          "type": "text"
        },
        {
          "id": "address",
          "text": "Address",
          "type": "text"
        },
        {
          "id": "city",
          "text": "City",
          "type": "text"
        },
        {
          "id": "state",
          "text": "State",
          "type": "select",
          "options": USA_STATES.map((state) => { return { value: state.key, text: state.name } })
        },
        {
          "id": "survey_type",
          "text": "Survey Type",
          "type": "select",
          "options": SURVEY_TYPES.map((type) => { return { value: type.key, text: type.name } })
        },
        {
          "id": "zip",
          "text": "Zip Code",
          "type": "text"
        },
        {
          "id": "phone",
          "text": "Phone",
          "type": "text"
        },
        {
          "id": "fax",
          "text": "Fax",
          "type": "text"
        },
        {
          "id": "contact_name",
          "text": "Contact Name",
          "type": "text"
        },
        {
          "id": "contact_title",
          "text": "Contact Title",
          "type": "text"
        },
        {
          "id": "contact_email",
          "text": "Contact Email",
          "type": "text"
        },
        {
          "id": "manager_name",
          "text": "Manager Name",
          "type": "text"
        },
        {
          "id": "no_of_room",
          "text": "Number of Rooms",
          "type": "text"
        },
        {
          "id": "luxury_flg",
          "text": "Luxury Property",
          "type": "select",
          "options": [{ value: true, text: "Yes" }, { value: false, text: "No"}]
        },
        {
          "id": "union_flg",
          "text": "Union Property",
          "type": "select",
          "options": [{ value: true, text: "Yes" }, { value: false, text: "No"}]
        },
        {
          "id": "inn_flg",
          "text": "Inn Property",
          "type": "select",
          "options": [{ value: true, text: "Yes" }, { value: false, text: "No"}]
        },
        {
          "id": "golf_flg",
          "text": "Golf Property",
          "type": "select",
          "options": [{ value: true, text: "Yes" }, { value: false, text: "No"}]
        },
        {
          "id": "limited_flg",
          "text": "Limited Property",
          "type": "select",
          "options": [{ value: true, text: "Yes" }, { value: false, text: "No"}]
        },
        {
          "id": "zone_id",
          "text": "Zone",
          "type": "select",
          "options": SOUTHERN_CALIFORNIA_PROPERTY_ZONES.map((zone) => { return { value: zone.key, text: zone.name } })
        },
        {
          "id": "createdAt",
          "text": "Create At",
          "type": "text",
          "disabled": true
        }
      ]
    }

    this.validator = new Validator({
      validationOptions: {
        "propertyname": ["required", { "type": "max", "value": 255 }],
        "address": ["required", { "type": "max", "value": 255 }],
        "city": ["required", { "type": "max", "value": 50 }],
        "state": ["required", { "type": "max", "value": 50 }],
        "survey_type": ["required"],
        "zip": ["required", { "type": "max", "value": 50 }],
        "phone": ["required", { "type": "max", "value": 50 }],
        "fax": [{ "type": "max", "value": 50 }],
        "contact_name": ["required",{ "type": "max", "value": 255 }],
        "contact_title": ["required",{ "type": "max", "value": 255 }],
        "contact_email": ["required","email"],
        "manager_name": ["required", { "type": "max", "value": 255 }],
        "no_of_room": ["required", "number", { "type": "lt", "value": 100000 }],
        "luxury_flg": ["required"],
        "union_flg": ["required"],
        "inn_flg": ["required"],
        "golf_flg": ["required"],
        "limited_flg": ["required"],
        "zone_id": ["required"]
      }
    });
  }

  setFormValue(field, value) {
    this.setState({
      "formValues": {
        ...this.state.formValues,
        [field]: value
      }
    }, () => {
      if ( this.state.formErrors[field] ) {
        let result = this.validator.validate({ [field]: this.state.formValues[field] });
        this.setFormErrors(result.messages);
      }
    });
  }

  setFormErrors(errors, callback = () => {}) {
    this.setState({
      "formErrors": {
        ...this.state.formErrors,
        ...errors
      }
    });
  }

  submitForm() {
    let result = this.validator.validate(this.state.formValues);
    let message = "";
    let color = "";
    let formErrors = {};
    if ( !result.error ) {
      let promise;
      if ( this.state.propertyId ) {
        promise = APIUpdateProperty(this.state.propertyId, this.state.formValues).then((result) => {
          if ( !result.error ) {
            message = "Property has been updated.";
            color = "success";
          } else {
            message = "Something went wrong. Please contact administrator.";
            color = "danger";
          }
          return { message: message, color: color };
        });
      }
      // else {
      //   promise = APICreateUserProperty(this.props.id, this.state.formValues).then((result) => {
      //     if ( !result.error ) {
      //       message = "Property has been updated.";
      //       color = "success";
      //     } else {
      //       message = "Something went wrong. Please contact administrator.";
      //       color = "danger";
      //     }
      //     return { message: message, color: color };
      //   });
      // }
      promise
        .catch((error) => {
          let message = "";
          if ( error.response && error.response.data ) {
            message = error.response.data.message;
          } else {
            message = error.message;
          }
          return { message: message, color: "danger" };
        }).finally(() => {
          this.setState({
            formAlert: {
              message: message,
              color: color
            },
            formErrors: result.messages
          });
        });
    } else {
      this.setFormErrors(result.messages);
    }

  }

  componentWillMount() {
    const id = this.props.id;
    APIGetProperty(id).then((result) => {
      if ( !result.error ) {
        let state = {
          formValues: {},
          formErrors: {},
          formAlert: {
            message: "",
            color: ""
          }
        };
        if ( result.data != null ) {
          state.formValues = result.data
          this.setState({
            "formValues": {
              ...this.state.formValues,
              ...state.formValues
            },
            "propertyId": result.data.id
          });
        }
      }
    });
  }

  dismissAlert() {
    this.setState({
      formAlert: {
        color: "",
        message: ""
      }
    });
  }

  render() {
    return (
      <Row>
        <Col xs="12" lg="8">
          <SmartForm
            form={this.form}
            formValues={this.state.formValues}
            formErrors={this.state.formErrors}
            onSetFormValue={(field, value) => this.setFormValue(field, value)}
            onSubmit={() => this.submitForm()}
            onAlertDismiss={() => this.dismissAlert()}
            alert={this.state.formAlert} />
        </Col>
      </Row>
    );
  }

}

export default Property;



// WEBPACK FOOTER //
// ./src/views/Users/View/tabs/Property.js